var map = {
	"./DJI_0023.jpg": "7dad",
	"./DJI_0024.jpg": "94d4",
	"./DJI_0025.jpg": "c367",
	"./DJI_0026.jpg": "298a",
	"./DJI_0027.jpg": "5b41"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1ca";